<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path fill-rule="evenodd" clip-rule="evenodd"
        d="M10.2295 18L16.7496 11.5L10.2295 5L9.00001 6.22565L14.2907 11.5L9.00001 16.7743L10.2295 18Z" />
</svg>